import { atom } from "jotai";
import { darkModeAtom } from "./atoms";

const themeModeAtom = atom((get) => (get(darkModeAtom) ? "dark" : "light"));

export { themeModeAtom };
